import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganization } from '../contexts/OrganizationContext';

function Page2({ formData, updateFormData, onNext, onBack }) {
  const { t } = useTranslation();
  const { organization } = useOrganization();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateFormData({ [name]: value });
  };

  const handleNext = (e) => {
    e.preventDefault();
    onNext();
  };

  return (
    <form onSubmit={handleNext}>
      {/* Header */}
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          {t('page2.header.title')}
        </h1>
      </div>

      {/* Two Column Layout for Questions */}
      <div className="grid grid-cols-2 gap-8 mb-6">
        {/* Question 1 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.citizens')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="allDependentsCitizens"
                value="Yes"
                checked={formData.allDependentsCitizens === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="allDependentsCitizens"
                value="No"
                checked={formData.allDependentsCitizens === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>

        {/* Question 2 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.onlyPerson')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="onlyPersonClaiming"
                value="Yes"
                checked={formData.onlyPersonClaiming === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="onlyPersonClaiming"
                value="No"
                checked={formData.onlyPersonClaiming === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>
      </div>

      {/* Two Column Layout - Row 2 */}
      <div className="grid grid-cols-2 gap-8 mb-6">
        {/* Question 3 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.jointReturn')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="filingJointReturn"
                value="Yes"
                checked={formData.filingJointReturn === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="filingJointReturn"
                value="No"
                checked={formData.filingJointReturn === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>

        {/* Question 4 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.related')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="relatedToYou"
                value="Yes"
                checked={formData.relatedToYou === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="relatedToYou"
                value="No"
                checked={formData.relatedToYou === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>
      </div>

      {/* Full Width Question 5 */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-900 mb-3">
          {t('page2.questions.ageRequirement')} <span className="text-red-500">{t('common.required')}</span>
        </label>
        <div className="space-y-2">
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="meetsAgeRequirement"
              value="Yes"
              checked={formData.meetsAgeRequirement === 'Yes'}
              onChange={handleInputChange}
              className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              required
            />
            <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
          </label>
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="meetsAgeRequirement"
              value="No"
              checked={formData.meetsAgeRequirement === 'No'}
              onChange={handleInputChange}
              className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
            />
            <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
          </label>
        </div>
      </div>

      {/* Two Column Layout - Row 3 */}
      <div className="grid grid-cols-2 gap-8 mb-6">
        {/* Question 6 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.livesWithYou')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="livesWithYou"
                value="Yes"
                checked={formData.livesWithYou === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="livesWithYou"
                value="No"
                checked={formData.livesWithYou === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>

        {/* Question 7 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.financialSupport')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="financiallySupport"
                value="Yes"
                checked={formData.financiallySupport === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="financiallySupport"
                value="No"
                checked={formData.financiallySupport === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>
      </div>

      {/* Two Column Layout - Row 4 */}
      <div className="grid grid-cols-2 gap-8 mb-6">
        {/* Question 8 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.utilityBill')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="hasUtilityBill"
                value="Yes"
                checked={formData.hasUtilityBill === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="hasUtilityBill"
                value="No"
                checked={formData.hasUtilityBill === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>

        {/* Question 9 */}
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-3">
            {t('page2.questions.income')} <span className="text-red-500">{t('common.required')}</span>
          </label>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="dependentIncomeLessThan4200"
                value="Yes"
                checked={formData.dependentIncomeLessThan4200 === 'Yes'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                required
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.yes')}</span>
            </label>
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="dependentIncomeLessThan4200"
                value="No"
                checked={formData.dependentIncomeLessThan4200 === 'No'}
                onChange={handleInputChange}
                className="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <span className="ml-3 text-sm text-gray-800">{t('common.no')}</span>
            </label>
          </div>
        </div>
      </div>

      {/* Question 10 - Child Care Expenses */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-900 mb-2">
          {t('page2.questions.childCare')} <span className="text-red-500">{t('common.required')}</span>
        </label>
        <input
          type="text"
          name="childCareExpenses"
          value={formData.childCareExpenses}
          onChange={handleInputChange}
          placeholder={t('page2.questions.childCarePlaceholder')}
          className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          required
        />
      </div>

      {/* Certification Text */}
      <div className="mb-6 p-4 bg-gray-50 rounded border border-gray-200">
        <p className="text-xs text-gray-700 leading-relaxed">
          {t('page2.certification', { organizationName: organization?.name || 'Tax Services' })}
        </p>
      </div>

      {/* Navigation Buttons */}
      <div className="flex gap-4">
        <button
          type="button"
          onClick={onBack}
          className="w-1/2 bg-gray-200 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-300 transition-colors font-medium text-lg"
        >
          {t('common.back')}
        </button>
        <button
          type="submit"
          className="w-1/2 bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium text-lg"
        >
          {t('common.next')}
        </button>
      </div>
    </form>
  );
}

export default Page2;
